module.exports = __webpack_public_path__ + "media/images/emblems/GW-GL-Glarus_neu-1bfb72290355f13d58ed9d98fd63ba3a.png";